import React from 'react';
import PropTypes from 'prop-types';

import introHtml from './static/intro.html';
import howHtml from './static/how.html';
import customizeHtml from './static/customize.html';
import styleHtml from './static/style.html';
import refHtml from './static/ref.html';

import NotFound from '../NotFound';

class HtmlPage extends React.PureComponent {

	componentDidMount() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	componentDidUpdate() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	render() {

		const { page } = this.props;

		let html = null;
		switch (page) {
			case 'Intro': html = <div dangerouslySetInnerHTML={{ __html: introHtml }} />; break;
			case 'How': html = <div dangerouslySetInnerHTML={{ __html: howHtml }} />; break;
			case 'Customize': html = <div dangerouslySetInnerHTML={{ __html: customizeHtml }} />; break;
			case 'Style': html = <div dangerouslySetInnerHTML={{ __html: styleHtml }} />; break;
			case 'Ref': html = <div dangerouslySetInnerHTML={{ __html: refHtml }} />; break;
			default: return (<NotFound partial={true} />);
		}

		return html;
	}
}

HtmlPage.propTypes = {
	page: PropTypes.string.isRequired
};

export default HtmlPage;



// WEBPACK FOOTER //
// ./src/components/widgets/HtmlPage.js